import axios from 'axios';
import React, { useState, useEffect } from 'react';

import moment from '../../../../utils/MomentConst';
import styled from 'styled-components'
import { Flex, Text, Spinner } from "../../../../components";
import Cooldown from "./Cooldown";
import { Modal, ModalContainer, ModalButton, Input, Select, Label, TextArea } from "../../components";
import { NotificationContainer, NotificationManager } from 'react-notifications';

const Content = styled(Flex)`
  padding: 0 30px;
`;

const HeaderRow = styled(Flex)`
  border-bottom: 1px solid #414568;
  padding: 18px 24px;
  margin-bottom: 24px;
  color: #7178B2;
  font-weight: 600;
  font-size: 12px;
`;

const ItemHeading = styled(Text.Body)`
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 16px;
`;

const Grid = styled.div`
  width: 100%;
  display: grid;
  grid-gap: 20px;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
`;

const Item = styled(Flex)`
  flex-direction: column;
  border: 1px solid #414568;
  border-radius: 6px;
  padding: 20px;
  height: fit-content;
`;

const Types = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [userData, setUserData] = useState(null);
  const [licenses, setLicenses] = useState(null);
  const [cdLicenses, setCdLicenses] = useState(null);
  const [welcomeConfig, setWelcomeConfig] = useState(null);
  const [upcomingPaymentConfig, setUpcomingPaymentConfig] = useState(null);
  const [failedPaymentConfig, setFailedPaymentConfig] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showInstancesModal, setShowInstancesModal] = useState(false);
  const [instancesPriceConfig, setInstancesPriceConfig] = useState(null);
  const [instancesEnabledConfig, setInstancesEnabledConfig] = useState(null);
  const [instancesHoursConfig, setInstancesHoursConfig] = useState(null);
  const [instancesMaxCountConfig, setInstancesMaxCountConfig] = useState(null);
  const [stripePrices, setStripePrices] = useState(false);

  const [configPayload, setConfigPayload] = useState({
    config_label: "",
    config_data: "",
    discord_id: ""
  });

  const [cdPayload, setCdPayload] = useState({
    license_id: "",
    until: moment()
  });

  const [instancesEditPayload, setInstancesEditPayload] = useState({
    price_id: "",
    hours: 0,
    maxCount: 0
  });

  const submitInstancesEditPayload = () => {
    axios({
      method: 'POST',
      url: '/api/admin/settings/update-instances-config',
      data: instancesEditPayload,
    }).then(res => {
      setInstancesPriceConfig(res.data.price_config);
      setInstancesHoursConfig(res.data.hours_config);
      setInstancesMaxCountConfig(res.data.max_count_config)
      setShowInstancesModal(false);
      setIsLoading(false);
    });
  }

  const submitInstancesStatus = () => {
    axios({
      method: 'POST',
      url: '/api/admin/settings/update-instances-status',
      data: { 
        status: instancesEnabledConfig.data == 1 ? 0 : 1
      },
    }).then(res => {
      setInstancesEnabledConfig(res.data.updatedConfig);
      setIsLoading(false);
    });
  }

  const submitConfigTest = (configLabel) => {

    setIsLoading(true);

    switch (configLabel) {

      case 'welcome_message':

        if (configPayload.config_label == configLabel && configPayload.config_data != welcomeConfig.data) {

          axios({
            method: 'POST',
            url: '/api/admin/settings/test-config-message',
            data: configPayload,
          }).then(res => {
            setIsLoading(false);
          });

        } else {

          axios({
            method: 'POST',
            url: '/api/admin/settings/test-config-message',
            data: {
              config_label: 'welcome_message',
              config_data: welcomeConfig.data,
              discord_id: userData.discord_id
            },
          }).then(res => {
            setIsLoading(false);
          });

        }

        break;
      case 'upcoming_payment_message':

        if (configPayload.config_label == configLabel && configPayload.config_data != upcomingPaymentConfig.data) {

          axios({
            method: 'POST',
            url: '/api/admin/settings/test-config-message',
            data: configPayload,
          }).then(res => {
            setIsLoading(false);
          });

        } else {

          axios({
            method: 'POST',
            url: '/api/admin/settings/test-config-message',
            data: {
              config_label: 'upcoming_payment_message',
              config_data: upcomingPaymentConfig.data,
              discord_id: userData.discord_id
            },
          }).then(res => {
            setIsLoading(false);
          });

        }

        break;
      case 'payment_failed_message':

        if (configPayload.config_label == configLabel && configPayload.config_data != failedPaymentConfig.data) {

          axios({
            method: 'POST',
            url: '/api/admin/settings/test-config-message',
            data: configPayload,
          }).then(res => {
            setIsLoading(false);
          });

        } else {

          axios({
            method: 'POST',
            url: '/api/admin/settings/test-config-message',
            data: {
              config_label: 'payment_failed_message',
              config_data: failedPaymentConfig.data,
              discord_id: userData.discord_id
            },
          }).then(res => {
            setIsLoading(false);
          });

        }

        break;

    }

  }

  const submitConfigSave = (configLabel) => {

    setIsLoading(true);

    switch (configLabel) {

      case 'welcome_message':

        if (configPayload.config_label == configLabel && configPayload.config_data != welcomeConfig.data) {

          axios({
            method: 'PUT',
            url: '/api/admin/settings/update-config-message',
            data: configPayload,
          }).then(res => {
            setWelcomeConfig(res.data.updatedConfig);
            setIsLoading(false);
          });

        } else {

          setIsLoading(false);
          NotificationManager.error('No changes', '');

        }

        break;
      case 'upcoming_payment_message':

        if (configPayload.config_label == configLabel && configPayload.config_data != upcomingPaymentConfig.data) {

          axios({
            method: 'PUT',
            url: '/api/admin/settings/update-config-message',
            data: configPayload,
          }).then(res => {
            setUpcomingPaymentConfig(res.data.updatedConfig);
            setIsLoading(false);
          });

        } else {

          setIsLoading(false);
          NotificationManager.error('No changes', '');

        }

        break;

      case 'payment_failed_message':

        if (configPayload.config_label == configLabel && configPayload.config_data != failedPaymentConfig.data) {

          axios({
            method: 'PUT',
            url: '/api/admin/settings/update-config-message',
            data: configPayload,
          }).then(res => {
            setFailedPaymentConfig(res.data.updatedConfig);
            setIsLoading(false);
          });

        } else {

          setIsLoading(false);
          NotificationManager.error('No changes', '');

        }

        break;

    }

  }

  const submitNewCooldown = () => {

    setIsLoading(true);

    axios({
      method: 'POST',
      url: '/api/admin/settings/create-cooldown',
      data: cdPayload,
    }).then(res => {
      setCdLicenses(res.data.cdLicenses);
      setShowModal(false);
      setIsLoading(false);
    });

  }

  const deleteCooldown = (licenseId) => {

    setIsLoading(true);

    axios({
      method: 'DELETE',
      url: `/api/admin/settings/delete-cooldown?license_id=${licenseId}`,
    }).then(res => {
      setCdLicenses(res.data.cdLicenses);
      setIsLoading(false);
    });

  }

  const renderLicenses = () => {
    return (
      <Select
        onChange={(e) => {
          setCdPayload({
            ...cdPayload,
            license_id: e.target.value
          })
        }}
      >
        {licenses.map((value) => {
          return <option value={value.id}>{value.key}</option>
        })}
      </Select>
    )
  }

  useEffect(() => {
    axios
      .get('/api/admin/settings')
      .then(res => {
        setUserData(res.data.userData);
        setLicenses(res.data.licenses);
        setCdPayload({
          ...cdPayload,
          license_id: res.data.licenses.length > 0 ? res.data.licenses[0].id : null
        });
        setCdLicenses(res.data.cdLicenses);
        setConfigPayload({
          ...configPayload,
          discord_id: res.data.userData.discord_id
        });
        setWelcomeConfig(res.data.welcomeConfig);
        setUpcomingPaymentConfig(res.data.upcomingPaymentConfig);
        setFailedPaymentConfig(res.data.failedPaymentConfig);
        setInstancesPriceConfig(res.data.instancesProductConfig);
        setInstancesEnabledConfig(res.data.instancesEnabledConfig);
        setInstancesHoursConfig(res.data.instancesHoursConfig);
        setInstancesMaxCountConfig(res.data.instancesMaxCountConfig);
        setInstancesEditPayload({
          price_id: res.data.instancesProductConfig.data,
          hours: res.data.instancesHoursConfig.data,
          maxCount: res.data.instancesMaxCountConfig.data
        })
        setStripePrices(res.data.prices);
        setIsLoading(false);
      })
      .catch(err => {
        console.error(err);
      });
  }, []);

  if (isLoading) return (
    <Spinner></Spinner>
  );

  return (
    <>
      <Content dir="column" w='100%'>
        <Flex h="24px" />
        <Grid>
          <Item>
            <ItemHeading>Welcome Message</ItemHeading>
            <TextArea onChange={(e) => setConfigPayload({
              ...configPayload,
              config_label: 'welcome_message',
              config_data: e.target.value
            })}>{configPayload.config_label === 'welcome_message' ? configPayload.config_data : welcomeConfig.data}</TextArea>
            <Flex h="16px" />
            <Flex w='100%'>
              <ModalButton bg="#0393FF" onClick={() => submitConfigTest('welcome_message')}>Test</ModalButton>
              <Flex w="16px" />
              <ModalButton bg="#8A45FF" onClick={() => submitConfigSave('welcome_message')}>Save</ModalButton>
            </Flex>
          </Item>
          <Item>
            <ItemHeading>Upcoming Payment Message</ItemHeading>
            <TextArea onChange={(e) => setConfigPayload({
              ...configPayload,
              config_label: 'upcoming_payment_message',
              config_data: e.target.value
            })}>{configPayload.config_label === 'upcoming_payment_message' ? configPayload.config_data : upcomingPaymentConfig.data}</TextArea>
            <Flex h="16px" />
            <Flex w='100%'>
              <ModalButton bg="#0393FF" onClick={() => submitConfigTest('upcoming_payment_message')}>Test</ModalButton>
              <Flex w="16px" />
              <ModalButton bg="#8A45FF" onClick={() => submitConfigSave('upcoming_payment_message')}>Save</ModalButton>
            </Flex>
          </Item>
          <Item>
            <ItemHeading>Payment Failed Message</ItemHeading>
            <TextArea onChange={(e) => setConfigPayload({
              ...configPayload,
              config_label: 'payment_failed_message',
              config_data: e.target.value
            })}>{configPayload.config_label === 'payment_failed_message' ? configPayload.config_data : failedPaymentConfig.data}</TextArea>
            <Flex h="16px" />
            <Flex w='100%'>
              <ModalButton bg="#0393FF" onClick={() => submitConfigTest('payment_failed_message')}>Test</ModalButton>
              <Flex w="16px" />
              <ModalButton bg="#8A45FF" onClick={() => submitConfigSave('payment_failed_message')}>Save</ModalButton>
            </Flex>
          </Item>
          <Item>
            <ItemHeading>Cooldown</ItemHeading>
            <Text.Body>{cdLicenses.length} <span style={{ color: '#7178B2' }}>Licenses on Cooldown</span></Text.Body>
            <Flex h="16px" />
            <Flex w='100%'>
              <ModalButton bg="#0393FF" onClick={() => setShowModal(true)}>Add License</ModalButton>
            </Flex>
          </Item>
          <Item>
            <ItemHeading>Instances Config</ItemHeading>
            <Text.Body><span style={{ color: '#7178B2' }}>Current Price ID : </span>{instancesPriceConfig.data}</Text.Body>
            <Text.Body><span style={{ color: '#7178B2' }}>Current Max Count : </span>{instancesMaxCountConfig.data}</Text.Body>
            <Text.Body><span style={{ color: '#7178B2' }}>Current Hours : </span>{instancesHoursConfig.data}</Text.Body>
            <Flex h="16px" />
            <Flex w='100%'>
              <ModalButton bg="#0393FF" onClick={() => setShowInstancesModal(true)}>Edit Config</ModalButton>
              <Flex w="16px" />
              <ModalButton bg="#0393FF" onClick={() => submitInstancesStatus()}>{instancesEnabledConfig.data == 1 ? "Disable" : "Enable"}</ModalButton>
            </Flex>
          </Item>
        </Grid>
        <Flex h="18px" />
        <ItemHeading>Users on Cooldown</ItemHeading>
        <Flex h="18px" />
      </Content>
      <div style={{ width: '100%', maxWidth: '100%', overflow: 'auto' }}>
        <Content w="100%" minw="660px" dir="column">
          <HeaderRow w='100%' minw="600px">
            <Flex w="20%">Discord ID</Flex>
            <Flex w="20%">Key</Flex>
            <Flex w="20%">Until</Flex>
          </HeaderRow>
          {cdLicenses.map((value) => {
            return <Cooldown deleteCooldown={deleteCooldown} data={value} />
          })}
        </Content>
      </div>
      <NotificationContainer />

      {showModal &&
        <ModalContainer>
          <Modal dir="column">
            <Text.Heading size="18">Cooldown a License</Text.Heading>
            <Flex h="24px" />
            <Label>Licenses</Label>
            <Flex h="16px" />
            {renderLicenses()}
            <Flex h="24px" />
            <Label>Until</Label>
            <Flex h="16px" />
            <Input
              type="datetime-local"
              step="1"
              onChange={(e) => {
                setCdPayload({
                  ...cdPayload,
                  until: e.target.value
                })
              }}
            />
            <Flex h="24px" />
            <Flex dir="row" w="100%">
              <ModalButton onClick={() => setShowModal(false)} bg="#202441">Cancel</ModalButton>
              <Flex w="16px" />
              <ModalButton bg="#F32FE0" onClick={() => submitNewCooldown()}>Submit</ModalButton>
            </Flex>
          </Modal>
        </ModalContainer>
      }

      {showInstancesModal &&
        <ModalContainer>
          <Modal dir="column">
            <Text.Heading size="18">Edit Instances Config</Text.Heading>
            <Flex h="24px" />
            <Label>Price</Label>
            <Flex h="24px" />
            <Select
              value={instancesEditPayload.price_id != "" ? instancesEditPayload.price_id : instancesPriceConfig.data}
              onChange={(e) => {
                setInstancesEditPayload({
                  ...instancesEditPayload,
                  price_id: e.target.value
                })
              }}
            >
              {stripePrices.oneTimePrices.data.map((value) => {
                return <option value={value.id}>${value.unit_amount / 100} - {value.id}</option>
              })}
            </Select>
            <Flex h="24px" />
            <Label>Max Count</Label>
            <Flex h="24px" />
            <Input onChange={(e) => {
              setInstancesEditPayload({
                ...instancesEditPayload,
                maxCount: e.target.value
              })
            }}></Input>
            <Flex h="24px" />
            <Label>Hours</Label>
            <Flex h="24px" />
            <Input onChange={(e) => {
              setInstancesEditPayload({
                ...instancesEditPayload,
                hours: e.target.value
              })
            }}></Input>
            <Flex h="24px" />
            <Flex dir="row" w="100%">
              <ModalButton onClick={() => setShowInstancesModal(false)} bg="#202441">Cancel</ModalButton>
              <Flex w="16px" />
              <ModalButton bg="#F32FE0" onClick={() => submitInstancesEditPayload()}>Submit</ModalButton>
            </Flex>
          </Modal>
        </ModalContainer>
      }



    </>
  )
}

export default Types;
